import * as React from "react";
import Svg, { G, Path, Defs, ClipPath, Rect } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_997_4799)">
      <Path
        opacity={0.2}
        d="M12.5 1.25L11.25 7.5L16.25 9.375L7.5 18.75L8.75 12.5L3.75 10.625L12.5 1.25Z"
        fill="#0E8741"
      />
      <Path
        d="M12.5 1.25L11.25 7.5L16.25 9.375L7.5 18.75L8.75 12.5L3.75 10.625L12.5 1.25Z"
        stroke="#0E8741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_997_4799">
        <Rect width={20} height={20} fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
